import { render, staticRenderFns } from "./ExamGroups.vue?vue&type=template&id=b8cccfaa"
import script from "./ExamGroups.vue?vue&type=script&lang=js"
export * from "./ExamGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports